import Vue from 'vue'

export var bus = new Vue({
    methods: {
        ShowRestaurant() {
            this.$emit('ShowRestaurant')
        },
        GetAllRestaurant(data,value){
          this.$emit('GetAllRestaurant',data,value)
        },
        GetAllSedes(response){
            this.$emit('GetAllSedes',response)
        },
        GetAllCountry(response){
            this.$emit('GetAllCountry',response)
        },
        GetAllState(response){
            this.$emit('GetAllState',response)
        },
        GetAllCity(response){
            this.$emit('GetAllCity',response)
        },
        ResponseCreateRestaurant(response){
            this.$emit('ResponseCreateRestaurant',response)
        },
        ResponseUpdateRestaurant(response){
            this.$emit('ResponseUpdateRestaurant',response)
        },
        GetEditRestaurant(user){
            this.$emit('GetEditRestaurant',user)
        },
        GetAllrestaurantPagination(response) {
            this.$emit('GetAllrestaurantPagination', response)
        },
        GetAllrestaurantFull(response){
            this.$emit('GetAllrestaurantFull', response)
        },
        GetAllDealer(response){
            this.$emit('GetAllDealer', response)
        },
        GetAllDiscounts(response){
            this.$emit('GetAllDiscounts',response)
        },
        DeleteRestaurant(response){
            this.$emit('DeleteRestaurant',response)
        }
    }
});